export default "__VITE_ASSET__BPcfNJWs__"